import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {TabsModule} from '../../components/tabs/tabs.module';
import {CommonComponentsModule} from '../../common-components.module';

import {DatetimeModule} from '../../components/datetime/datetime.module';
import {FieldsModule} from '../../components/fields/fields.module';
import {SettingsAmenitiesService} from '../../services/settings-amenities.service';
import {SettingsAmenitiesComponent} from './settings-amenities.component';
import {SettingsAmenityFilterComponent} from '../../components/settings-amenities-filter/settings-amenities-filter.component';
import {SettingsAmenitiesListComponent} from './settings-amenities-list/settings-amenities-list.component';
import {SettingsAmenitiesDetailedViewComponent} from './settings-amenities-detailed-view/settings-amenities-detailed-view.component';
import {SettingsAmenitiesModalComponent} from './settings-amenities-modal/settings-amenities-modal.component';
import {AngularMaterialImportModule} from '../../components/angular-material-import-module/angular-material-import.module';
import {ScheduleModalComponent} from './schedule-modal/schedule-modal.component';
import {DisabledDatesModalComponent} from './disabled-dates-modal/disabled-dates-modal.component';
import {LegalAgreementModalComponent} from './legal-agreement-modal/legal-agreement-modal.component';
import {BookingRequestModalComponent} from './booking-request-modal/booking-request-modal.component';
import {DisclaimerModalComponent} from './disclaimer-modal/disclaimer-modal.component';
import {AngularMultiSelectModule} from '../../components/angular2-multiselect-dropdown/multiselect.component';
import {PaymentModalComponent} from './payment-modal/payment-modal.component';
import {SafeHtmlPipeModule} from '../../pipes/safe-html/safe-html-pipe.module';
import {RemindersModalComponent} from './reminders-modal/reminders-modal.component';
import {UtilsModule} from '../../modules/utils/utils.module';


@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        TabsModule,
        RouterModule,
        CommonComponentsModule,
        DatetimeModule,
        FieldsModule,
        AngularMaterialImportModule,
        AngularMultiSelectModule,
        SafeHtmlPipeModule,
        UtilsModule
    ],
    declarations: [
        SettingsAmenitiesComponent,
        SettingsAmenityFilterComponent,
        SettingsAmenitiesListComponent,
        SettingsAmenitiesDetailedViewComponent,
        SettingsAmenitiesModalComponent,
        ScheduleModalComponent,
        DisabledDatesModalComponent,
        LegalAgreementModalComponent,
        BookingRequestModalComponent,
        DisclaimerModalComponent,
        PaymentModalComponent,
        RemindersModalComponent
    ],
    providers: [
        SettingsAmenitiesService
    ]
})
export class SettingsAmenitiesModule {
}




// WEBPACK FOOTER //
// /app/src/app/views/settings-amenities/settings-amenities.module.ts